import { resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/images/reactions/like.png'
import _imports_1 from '@/assets/images/reactions/love.png'
import _imports_2 from '@/assets/images/reactions/haha.png'
import _imports_3 from '@/assets/images/reactions/celebrate.png'
import _imports_4 from '@/assets/images/reactions/gratitude.png'
import _imports_5 from '@/assets/images/reactions/wow.png'
import _imports_6 from '@/assets/images/reactions/sad.png'


const _hoisted_1 = {
  key: 0,
  class: "reaction-overlay"
}
const _hoisted_2 = {
  key: 0,
  src: _imports_0,
  alt: ""
}
const _hoisted_3 = {
  key: 1,
  src: _imports_1,
  alt: ""
}
const _hoisted_4 = {
  key: 2,
  src: _imports_2,
  alt: ""
}
const _hoisted_5 = {
  key: 3,
  src: _imports_3,
  alt: ""
}
const _hoisted_6 = {
  key: 4,
  src: _imports_4,
  alt: ""
}
const _hoisted_7 = {
  key: 5,
  src: _imports_5,
  alt: ""
}
const _hoisted_8 = {
  key: 6,
  src: _imports_6,
  alt: ""
}
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Like ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Vue3Lottie = _resolveComponent("Vue3Lottie")!
  const _component_AppIcon = _resolveComponent("AppIcon")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`reaction-input-container reaction-input-container__${_ctx.theme}`),
    onMouseenter: _cache[9] || (_cache[9] = ($event: any) => (_ctx.reactionHover())),
    onMouseleave: _cache[10] || (_cache[10] = ($event: any) => (_ctx.reactionUnhover()))
  }, [
    _createVNode(_Transition, { name: "pop" }, {
      default: _withCtx(() => [
        (_ctx.showReactionOverlay)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _withDirectives(_createVNode(_component_Vue3Lottie, {
                animationData: _ctx.AnimationLike,
                height: 36,
                width: 36,
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setReaction(_ctx.ReactionId.LIKE)))
              }, null, 8, ["animationData"]), [
                [_directive_tooltip, { distance: '12', content: 'Like' }]
              ]),
              _withDirectives(_createVNode(_component_Vue3Lottie, {
                animationData: _ctx.AnimationLove,
                height: 36,
                width: 36,
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setReaction(_ctx.ReactionId.LOVE)))
              }, null, 8, ["animationData"]), [
                [_directive_tooltip, { distance: '12', content: 'Love' }]
              ]),
              _withDirectives(_createVNode(_component_Vue3Lottie, {
                animationData: _ctx.AnimationHaha,
                height: 36,
                width: 36,
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setReaction(_ctx.ReactionId.HAHA)))
              }, null, 8, ["animationData"]), [
                [_directive_tooltip, { distance: '12', content: 'Haha' }]
              ]),
              _withDirectives(_createVNode(_component_Vue3Lottie, {
                animationData: _ctx.AnimationCelebrate,
                height: 36,
                width: 36,
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setReaction(_ctx.ReactionId.CELEBRATE)))
              }, null, 8, ["animationData"]), [
                [_directive_tooltip, { distance: '12', content: 'Celebrate' }]
              ]),
              _withDirectives(_createVNode(_component_Vue3Lottie, {
                animationData: _ctx.AnimationGratitude,
                height: 36,
                width: 36,
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setReaction(_ctx.ReactionId.GRATITUDE)))
              }, null, 8, ["animationData"]), [
                [_directive_tooltip, { distance: '12', content: 'Gratitude' }]
              ]),
              _withDirectives(_createVNode(_component_Vue3Lottie, {
                animationData: _ctx.AnimationWow,
                height: 36,
                width: 36,
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.setReaction(_ctx.ReactionId.WOW)))
              }, null, 8, ["animationData"]), [
                [_directive_tooltip, { distance: '12', content: 'Wow' }]
              ]),
              _withDirectives(_createVNode(_component_Vue3Lottie, {
                animationData: _ctx.AnimationSad,
                height: 36,
                width: 36,
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.setReaction(_ctx.ReactionId.SAD)))
              }, null, 8, ["animationData"]), [
                [_directive_tooltip, { distance: '12', content: 'Sad' }]
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (_ctx.modelValue)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.setReaction(undefined))),
          class: _normalizeClass(`action-button react-button react-button__${_ctx.theme} active`)
        }, [
          (_ctx.modelValue === 'Like')
            ? (_openBlock(), _createElementBlock("img", _hoisted_2))
            : (_ctx.modelValue === 'Love')
              ? (_openBlock(), _createElementBlock("img", _hoisted_3))
              : (_ctx.modelValue === 'Haha')
                ? (_openBlock(), _createElementBlock("img", _hoisted_4))
                : (_ctx.modelValue === 'Celebrate')
                  ? (_openBlock(), _createElementBlock("img", _hoisted_5))
                  : (_ctx.modelValue === 'Gratitude')
                    ? (_openBlock(), _createElementBlock("img", _hoisted_6))
                    : (_ctx.modelValue === 'Wow')
                      ? (_openBlock(), _createElementBlock("img", _hoisted_7))
                      : (_ctx.modelValue === 'Sad')
                        ? (_openBlock(), _createElementBlock("img", _hoisted_8))
                        : _createCommentVNode("", true),
          _createTextVNode(" " + _toDisplayString(_ctx.modelValue), 1)
        ], 2))
      : (_openBlock(), _createElementBlock("button", {
          key: 1,
          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.setReaction(_ctx.ReactionId.LIKE))),
          class: _normalizeClass(`action-button react-button react-button__${_ctx.theme}`)
        }, [
          _createVNode(_component_AppIcon, {
            name: "reaction-like",
            size: _ctx.iconSize
          }, null, 8, ["size"]),
          _hoisted_9
        ], 2))
  ], 34))
}